import { useMemo } from 'react';
import { FormularioComunidades } from 'interfaces/formularioComunidades.interface';
import { mapAssentamentoToForm, mapComunidadeToForm, generateUniqueId } from './step1.helpers';

type WizardState = {
  mode?: 'edit' | 'create';
  addType?: 'assentamentos' | 'comunidades';
  index?: number;
  item?: any;
  backTo?: string;
  pacoteId?: string;
};

export function useStep1Helpers(
  navState: WizardState,
  comunidadesRuraisTradicionais: any
) {
  const defaultsCreate: Partial<FormularioComunidades> = {
    unique_id: generateUniqueId(),
    step_atual: 1,
    ano_referencia: 2025 as any,
    tipo_cadastro: null,
    tipo_de_assentamento: null,
    codigo_do_pa: '',
    nome_do_assentamento: '',
    quantidade_de_familias: null,
  };

  const fromStore: Partial<FormularioComunidades> = {
    unique_id: comunidadesRuraisTradicionais?.current_form_unique_id ?? generateUniqueId(),
    step_atual: 1,
    ano_referencia: (comunidadesRuraisTradicionais?.ano_referencia_do_questionario ?? 2025) as any,
    tipo_cadastro: comunidadesRuraisTradicionais?.tipo_cadastro ?? null,
    tipo_de_assentamento: comunidadesRuraisTradicionais?.tipo_de_assentamento ?? null,
    codigo_do_pa: comunidadesRuraisTradicionais?.codigo_do_pa
      ? String(comunidadesRuraisTradicionais.codigo_do_pa).slice(0, 9)
      : '',
    nome_do_assentamento: comunidadesRuraisTradicionais?.nome_do_assentamento ?? '',
    quantidade_de_familias: comunidadesRuraisTradicionais?.quantidade_de_familias ?? null,
  };

  const initialValues = useMemo<Partial<FormularioComunidades>>(() => {
    if (navState.mode === 'edit') {
      if (navState.addType === 'assentamentos') return mapAssentamentoToForm(navState.item);
      return mapComunidadeToForm(navState.item);
    }
    if (navState.mode === 'create') {
      // Se current_form_unique_id existe, significa que já salvou o Passo 1 e está navegando
      // Neste caso, carrega os dados salvos do store
      const jaIniciadoPreenchimento = comunidadesRuraisTradicionais?.current_form_unique_id != null;
      if (jaIniciadoPreenchimento) {
        return { ...defaultsCreate, ...fromStore };
      }
      // Se current_form_unique_id é null, é um novo cadastro do zero
      return { ...defaultsCreate };
    }
    return { ...defaultsCreate, ...fromStore };
    // deps left minimal to caller control
  }, [navState.mode, navState.addType, JSON.stringify(navState.item), comunidadesRuraisTradicionais?.uuid, comunidadesRuraisTradicionais?.current_form_unique_id]);

  const tiposAssentamento = [
    { value: 3, label: 'FEDERAIS – PA' },
    { value: 4, label: 'FEDERAIS CASULO/PCA (parceria entre INCRA e município)' },
    { value: 5, label: 'ESTADUAIS – PE' },
    { value: 6, label: 'PROJETOS DO TERRA BRASIL/ PROGRAMA NACIONAL DE CRÉDITO FUNDIÁRIO (PNCF)/ BANCO DA TERRA' },
  ];

  const tiposCadastro = [
    { value: 1, label: 'Assentamento' },
    { value: 2, label: 'Comunidade Quilombola' },
  ];

  return {
    initialValues,
    defaultsCreate,
    fromStore,
    tiposAssentamento,
    tiposCadastro,
  };
}
